// extracted by mini-css-extract-plugin
export default {"badge":"w2vgaSk4","duration":"S1nBKcYE","stageLabel":"_1VJcv7Id","blue":"fN9zfYVc","yellow":"U4KF1br5","red":"_2WmwKcaV"};